<template>
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-12 p-0">
        <div class="login-card login-dark">
          <div>
            <div>
              <a class="logo" href="#">
                <img
                    class="img-fluid for-light m-auto"
                    src="assets/images/logo-light.png"
                    alt="resetpage"
                />
                <img
                    class="img-fluid for-dark"
                    src="assets/images/logo-dark.png"
                    alt="logo"
                />
              </a>
            </div>
            <div class="login-main">
              <form class="theme-form" @submit.prevent="handleResetPassword">
                <h2>Reset Your Password</h2>
                <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
                <h6 class="mt-4 f-w-700">Create Your Password</h6>
                <div class="form-group">
                  <label class="col-form-label">New Password</label>
                  <div class="form-input position-relative">
                    <input
                        class="form-control"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="newPassword"
                        required
                        placeholder="*********"
                    >
                    <div class="show-hide" @click="togglePassword">
                      <span :class="showPassword ? 'hide' : 'show'"></span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Retype Password</label>
                  <input
                      class="form-control"
                      type="password"
                      v-model="confirmPassword"
                      required
                      placeholder="*********"
                  >
                </div>
                <div class="form-group mb-0 checkbox-checked">
                  <button
                      class="btn btn-primary btn-block w-100 mt-3"
                      type="submit"
                      :disabled="loading"
                  >
                    {{ loading ? 'Resetting...' : 'Reset Password' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';

const props = defineProps({
  token: {type: String, required: true}
});

// Reactive state
const newPassword = ref('');
const confirmPassword = ref('');
const loading = ref(false);
const showPassword = ref(false);
const errorMessage = ref(null);

const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

const handleResetPassword = async () => {
  if (loading.value) return;

  // Validate passwords match
  if (newPassword.value !== confirmPassword.value) {
    errorMessage.value = 'Passwords do not match!';
    return;
  }

  loading.value = true;
  errorMessage.value = null;

  try {
    const response = await fetch('/api/authenticate/reset-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        newPassword: newPassword.value,
        token: props.token
      }),
    });

    if (response.redirected) {
      // Redirect to login page upon success
      window.location.href = '/';
    } else {
      // If response is not OK, show error message
      const errorText = await response.text();
      errorMessage.value = errorText || 'Failed to reset password. Please try again.';
    }
  } catch (error) {
    errorMessage.value = 'An error occurred. Please try again later.';
    console.error('Error resetting password:', error);
  } finally {
    loading.value = false;
  }
};
</script>